import { useEffect } from 'react'
import { useDimCatalog } from '~/api/hooks/useCatalog'
import { driverDimsOf } from '~/pin/driverArmFilters'

/** FU-03: the driver fact's dim set for pin-replay filter stripping (shared by both
 *  ChartFromPin driver arms). `pending` gates the driver walk while the catalog loads so it
 *  fires exactly once, already stripped. `dims` null AFTER settle = catalog unavailable →
 *  callers fire unstripped (pre-FU-03 behavior) and this hook warns — visible degradation,
 *  never a silently disabled driver arm (no-silent-fallbacks). */
export function useDriverDims(
  driverFact: string,
  enabled: boolean,
): { dims: Set<string> | null; pending: boolean } {
  const dimCatalog = useDimCatalog()
  useEffect(() => {
    if (enabled && !dimCatalog.isPending && !dimCatalog.data)
      console.warn(
        `ChartFromPin: dim catalog unavailable — the "${driverFact}" driver arm replays its frozen filters unstripped.`,
      )
  }, [enabled, dimCatalog.isPending, dimCatalog.data, driverFact])
  return {
    dims: driverDimsOf(dimCatalog.data, driverFact),
    pending: enabled && dimCatalog.isPending,
  }
}
